import React from "react";
import ProjectCard from "../ProjectCard";
import { maginate, portfolio, bankbridge, pca } from "../../assets/index";

const Projects = () => {
  var projectList = [
    {
      header: "MaginateAI",
      duration: "Oct 2024 - Nov 2024",
      src: maginate,
      description:
        "Built a full-stack website for AI-powered image generation, allowing users to create images from text prompts and share their creations on a community page for others to explore.",
      visitLink: "https://maginate.vercel.app/",
      codeLink: "https://github.com/anshuman0799/maginate",
    },
    {
      header: "Bank Bridge",
      duration: "Jun 2024 - Sep 2024",
      src: bankbridge,
      description:
        "Developed a full-stack expense management app that securely connects to bank accounts using Plaid for real-time transaction tracking and financial management.",
      visitLink: "https://bankbridgeapp.vercel.app/",
      codeLink: "https://github.com/anshuman0799/bankbridge",
    },
    {
      header: "My Portfolio Website",
      duration: "Jul 2024 - Aug 2024",
      src: portfolio,
      description:
        "Built a React.js portfolio site to showcase my skills and projects, featuring a visually engaging and user-friendly design, with smooth navigation and responsive layout.",
      visitLink: "https://anshumanrao.vercel.app/",
    },
    {
      header: "PCA Seed Analysis",
      duration: "Mar 2024 - Apr 2024",
      src: pca,
      description:
        "Used PCA on rice seed data with Python to enhance feature selection and classification, analyzing various rice varieties with machine learning algorithms.",
      visitLink:
        "https://colab.research.google.com/github/anshudabar/INSE6220/blob/main/PCA_RiceSeeds.ipynb#scrollTo=q5M0XRr_VTOB",
      codeLink: "https://github.com/anshuman0799/INSE6220",
    },
  ];
  return (
    <section
      id="projects"
      className="w-full h-full py-10 flex flex-col border-b-[1px] border-b-black font-titleFont pb-20"
    >
      {" "}
      <div className="max-w-full lg:max-w-[1280px] w-full h-full m-auto px-4 xl:px-8">
        <div className="h-full md:w-[85%] mx-auto items-center gap-4">
          <h2 className="text-3xl lg:text-4xl w-full flex justify-center text-black xl:pt-4">
            Personal Projects
          </h2>
          <div className="mt-12 h-full">
            {projectList.map((item, i) => {
              return (
                <ProjectCard
                  key={i}
                  header={item.header}
                  duration={item.duration}
                  srcImage={item.src}
                  orderFirst={i % 2 === 0}
                  description={item.description}
                  visitLink={item.visitLink}
                  codeLink={item.codeLink}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
